import { render, staticRenderFns } from "./read.vue?vue&type=template&id=60a2efb2&scoped=true&"
import script from "./read.vue?vue&type=script&lang=js&"
export * from "./read.vue?vue&type=script&lang=js&"
import style0 from "./read.vue?vue&type=style&index=0&id=60a2efb2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a2efb2",
  null
  
)

export default component.exports